export type PARTNER_SCOPE_TYPES = 'read' | 'write';

export enum PARTNER_TYPES {
  API = 'api',
  COMMERCIAL_API = 'commercialapi',
  FHIR = 'fhir',
  INBOUND = 'inbound',
  INSULET = 'insulet',
  REDOX = 'redox',
}

export const INVITATION_RESPONSE_CODES = {
  Success: 0,
  IncorrectYOB: 1,
  NotFound: 2,
  InvalidYOB: 3,
  InvalidCode: 4,
  InvalidCodeAndYOB: 5,
  ExpiredCode: 6,
};
